import $ from "jquery";

import utils from "../helpers/utils";

// Merge the tabId into the existing query params rather than replacing them,
// so unrelated params (e.g. tracking/story params) aren't dropped from the URL.
function withTabIdParam(tabId: string): Record<string, string> {
  return { ...Object.fromEntries(utils.getUrlParameters()), tabId };
}

function init(): void {
  const $tabs = $("[data-tabs]");
  const $mobileSelect = $(".js-mobile-tab-select");
  const $mobileSelectOption = $(".js-mobile-tab");

  if ($tabs.length) {
    // Store a clicked tab id in the URL
    $(".js-tab").click(function() {
      const params = withTabIdParam(this.getAttribute("href").replace("#", ""));
      window.history.pushState(params, "Current tab state", "?" + utils.serializeParams(params));
    });
  }
  if ($mobileSelect.length) {
    // Store a selected option id in the URL
    $mobileSelect.each(function() {
      $(this).on("change", function() {
        const value = this.value;
        const params = withTabIdParam(value.replace("#", "").replace("-mobile", ""));
        $(`#${value} .js-tab`).click();
        window.history.pushState(params, "Current tab state", "?" + utils.serializeParams(params));
      });
    });
  }

  window.addEventListener("load", () => {
    const tabId = utils.getUrlParameter("tabId");
    const $tabToOpen = $(`#${tabId} .js-tab`);

    // On page load, open a tab if provided in the URL
    if ($tabs.length && tabId && $tabToOpen.length) {
      const headH = utils.isMobile() ? 0 : $(".js-header").outerHeight() + 40;
      $("html, body").animate({ scrollTop: $tabToOpen.offset().top - headH }, 500);
      setTimeout(() => $tabToOpen.click());
    }
    // On page load pre-select a mobile option if provided in the URL
    if ($mobileSelect.length && $mobileSelectOption.length) {
      const $selectedMobileTab = $(`.js-mobile-tab[value=${tabId}]`); // Find correct select in case of unlikely but possible duplicates
      const $select = $selectedMobileTab.parent(".js-mobile-tab-select"); // Grab the select element to set the value on
      $select.val(tabId);
    }
  });
}

export default { init };
